import { render } from "./CancelIcon.vue?vue&type=template&id=72731541&scoped=true"
import script from "./CancelIcon.vue?vue&type=script&lang=js"
export * from "./CancelIcon.vue?vue&type=script&lang=js"

import "./CancelIcon.vue?vue&type=style&index=0&id=72731541&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72731541"]])

export default __exports__